export interface DataType {
    key: string;
    logo: string | null;
    company: string;
    fee: string;
    approvalChance: string;
    status: string;
    statusType: "active" | "inactive";
}

export const initialData: DataType[] = [
    {
        key: "1",
        logo: null,
        company: "Zaplo",
        fee: "0 %",
        approvalChance: "80 %",
        status: "Aktivní",
        statusType: "active",
    },
    {
        key: "2",
        logo: null,
        company: "Cool Credit",
        fee: "25 %",
        approvalChance: "70 %",
        status: "Neaktivní",
        statusType: "inactive",
    },
];
